import * as React from "react";
import { Lightbox } from "../../../../../../../react-core/Html/Components/Lightbox";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { AddBeneficiary } from "../../../AddClient/Components/Organisation/AddBeneficiary";

interface IEditBeneficiaryLightboxProps {
    data: FullClientDetailModel;
    onClose: () => void;
    onSave: (data: FullClientDetailModel) => void;
}

interface IEditBeneficiaryLightboxState {
    data: FullClientDetailModel;
    errorMsg: string[];
}

export class EditBeneficiaryLightbox extends FormComponent<
    IEditBeneficiaryLightboxProps,
    IEditBeneficiaryLightboxState
> {
    constructor(props: IEditBeneficiaryLightboxProps) {
        super(props);
        this.state = {
            data: JSON.parse(JSON.stringify(props.data)),
            errorMsg: [],
        };
    }

    private form;

    isValid() {
        return super.isValid() && this.form.isValid();
    }

    onChange(changes) {
        const { data } = this.state;
        for (const key in changes) {
            data[key] = changes[key];
        }
        this.setState({ data });
    }

    render() {
        const { data, errorMsg } = this.state;

        return (
            <Lightbox
                cssWrapper="is-default-lightbox"
                onClose={() => this.props.onClose()}
                show={true}
                title={"Edit beneficiary"}
            >
                {errorMsg.map((msg) => {
                    return <Alert alertType={AlertType.Error} message={msg} />;
                })}
                <AddBeneficiary
                    data={data}
                    onChange={(change) => {
                        this.onChange(change.Individual);
                        this.setState({ errorMsg: [] });
                    }}
                    onRef={(ref) => {
                        this.form = ref;
                    }}
                    showErrorMsgPopUp={(msg, showNow) => this.setState({ errorMsg: msg })}
                />
                <br />
                <button className="btn secondary mr-10" onClick={() => this.props.onClose()}>
                    Cancel
                </button>
                <button
                    className="btn primary"
                    onClick={() => {
                        if (this.isValid()) {
                            this.props.onSave(this.state.data);
                        }
                    }}
                >
                    Save
                </button>
            </Lightbox>
        );
    }
}
